module.exports = __webpack_public_path__ + "img/check-green.82972b47.svg";